var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"inline-flex space-x-2 text-primary hover:text-gray-600",attrs:{"type":"button"},on:{"click":function($event){return _vm.$emit('click')}}},[_c('div',{staticClass:"items-center"},[_vm._t("icon"),_vm._t("default",function(){return [_vm._v("BUTTON TEXT")]})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }